import { Link, useSearchParams } from "react-router-dom";
import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useRef, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import { walletsTransactionColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { convertDate } from "../../utils/convertDate";
import PaymentStatusModal from "./sub-components/paymentStatusModal/PaymentStatusModal";
import { digitsThree } from "../../utils/price";
import UserReportsFilter from "./WalletsFilter";

export default function WalletsTransaction() {
  const [searchParams] = useSearchParams();
  const batchId = searchParams.get("batchId") || "";
  const tableRequest = useTableRequest({ initialLoading: true });
  const [walletTransactions, setWalletsTransactions] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [totalBalance, setTotalBalance] = useState(null);

  const { utils } = useSelector(utilsState);

  const getWalletsTransactions = async (params) => {
    const path = "admin/wallets";
    return tableRequest.load({ path, params: { ...params, ...(batchId ? { batchId } : {}) } }, (response) => {
      setWalletsTransactions(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  const getWallet = async () => {
    const path = "admin/wallets/totalBalance";
    try {
      const response = await getApi({ path });
      console.log(response);
      setTotalBalance(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWalletsTransactions({});
    getWallet();
  }, [batchId]);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getWalletsTransactions(allFilter);
  };

  const data = [];

  walletTransactions?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      source: (item.batchId || item.reversalBatchId) ? <Link to={`/wallets/bulk-history?batchId=${encodeURIComponent(item.batchId || item.reversalBatchId)}`} className="inline-block rounded-full bg-blue-50 px-3 py-1 text-blue-700 dark:bg-blue-950 dark:text-blue-200" title={item.batchId || item.reversalBatchId}>{item.reversalBatchId ? "برگشت واریز گروهی" : "واریز گروهی"} · {(item.batchId || item.reversalBatchId).slice(0, 8)}</Link> : "عادی",
      name: item?.user?.name,
      mobile: item?.user?.mobile,
      id: item._id,
      amount: digitsThree(item?.amount),
      paymentStatus: item.paymentStatus,
      faPaymentStatus: utils?.PAYMENT_STATUS[item.paymentStatus]?.name,
      type: item.type == "deposit" ? "واریز" : "برداشت",
      isCommission: item.isCommission ? "بله" : "خیر",
      date: convertDate(item?.createdAt),
    })
  );

  const paymentStatusRef = useRef();

  const [transactionData, setTransactionData] = useState(null);

  const chnagePaymentStatus = (data) => {
    setTransactionData(data);
    paymentStatusRef.current.showModal();
  };

  return (
    <>
        <div className="w-full flex justify-start mt-6 mb-6">
          <div className=" bg-white dark:bg-gray-900 flex items-center justify-center gap-5 p-6 rounded-lg border border-gray-200 shadow-md">
            <div className="flex items-center justify-center gap-3">
              <p>موجودی کیف پول :</p>
              <p>{digitsThree(totalBalance)}</p>
            </div>
            <img
              src={require("./../../assets/image/wallet.png")}
              alt="wallet"
              className="h-12 w-20"
            />
          </div>
        </div>

      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={"لیست تراکنش ها"} />
        <Link to="/wallets/bulk-history" className="text-blue-700 dark:text-blue-300">سوابق و لغو واریز گروهی</Link>
        {batchId && <p className="mt-4 break-all">تراکنش‌های واریز گروهی: <bdi>{batchId}</bdi> <Link to="/wallets-transaction" className="mr-3 text-blue-700">حذف فیلتر گروه</Link></p>}
        <PaymentStatusModal
          reGetData={getWalletsTransactions}
          ref={paymentStatusRef}
          transactionData={transactionData}
        />
        <UserReportsFilter filterDataHandler={filterDataHandler} />
        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
        <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry}
          columns={walletsTransactionColumns}
          rows={data}
          canCustomFunction={(row) => !row.batchId && !row.reversalBatchId}
          onCustomFunction={chnagePaymentStatus}
          customFunctionName="ویرایش وضعیت"
        />

        <Pagination
          pagination={pagination}
          filterDataHandler={filterDataHandler}
        />
      </div>
    </>
  );
}
